import { useEffect } from 'react';

import { needsImagePrintDetail } from 'editor/src/store/editorModules/warnings/utils/getPrintRuleWarnings';
import analyzeImagePrintDetailOperation from 'editor/src/store/gallery/operation/analyzeImagePrintDetailOperation';
import { ImageState } from 'editor/src/store/gallery/types';
import hasCurrentPrintDetail from 'editor/src/store/gallery/utils/hasCurrentPrintDetail';
import { useDispatch, useSelector, useStore } from 'editor/src/store/hooks';
import isImagePrintCheckEnabled from 'editor/src/store/hostSettings/selector/isImagePrintCheckEnabled';

// Measures once each image placed on a spread whose print checks read its pixels.
function usePrintDetailWatcher() {
  const store = useStore();
  const dispatch = useDispatch();
  // the hook runs in App, so with the checks off it subscribes to nothing that changes often
  const enabled = useSelector(isImagePrintCheckEnabled);
  const designData = useSelector((state) => (enabled ? state.design.designData : undefined));
  const images = useSelector((state) => (enabled ? state.gallery.images : undefined));
  const enabledWarnings = useSelector((state) => (enabled ? state.hostSettings.enabledWarnings : undefined));
  const printTechRules = useSelector((state) => (enabled ? state.hostSettings.printTechRules : undefined));

  useEffect(() => {
    if (!designData || !enabledWarnings) {
      return;
    }
    const { gallery } = store.getState();
    designData.spreads.forEach((spread) => {
      if (!needsImagePrintDetail(spread.technology, enabledWarnings, printTechRules)) {
        return;
      }
      spread.pages[0]?.groups.media?.forEach((element) => {
        if (element.type !== 'image' || !element.imageId || element.hidden || element.sample) {
          return;
        }
        const image = gallery.images.find((img) => img.id === element.imageId);
        if (image?.url && image.state === ImageState.UPLOADED && !hasCurrentPrintDetail(image)) {
          void dispatch(analyzeImagePrintDetailOperation(element.imageId));
        }
      });
    });
  }, [designData, images, enabledWarnings, printTechRules]);
}

export default usePrintDetailWatcher;
